import { reportWidgetEvent } from './report-widget-event.js';
import type { PopupKind } from './widget-event-types.js';

type ActiveRetention = {
  kind: PopupKind;
  shownAt: number;
  pathname: string;
  convertedToChat: boolean;
};

let activeRetention: ActiveRetention | null = null;
let pageHideHandler: (() => void) | null = null;

const RETENTION_DELAYS_MS = [30_000, 60_000] as const;

export function startPopupRetentionTracking(kind: PopupKind): void {
  stopPopupRetentionTracking();

  const shownAt = Date.now();
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '/';

  activeRetention = {
    kind,
    shownAt,
    pathname,
    convertedToChat: false,
  };

  for (const delayMs of RETENTION_DELAYS_MS) {
    window.setTimeout(() => {
      if (!activeRetention || activeRetention.shownAt !== shownAt) return;

      reportWidgetEvent('popup_retention_check', {
        kind,
        delay_ms: delayMs,
        stayed_visible: document.visibilityState === 'visible',
        same_pathname: window.location.pathname === pathname,
        converted_to_chat: activeRetention.convertedToChat,
      });
    }, delayMs);
  }

  pageHideHandler = () => {
    if (!activeRetention || activeRetention.shownAt !== shownAt) return;

    reportWidgetEvent('popup_user_left', {
      kind,
      dwell_ms: Date.now() - shownAt,
      converted_to_chat: activeRetention.convertedToChat,
    });
    activeRetention = null;
  };

  window.addEventListener('pagehide', pageHideHandler);
}

export function markPopupConvertedToChat(): void {
  if (!activeRetention) return;
  activeRetention.convertedToChat = true;
}

export function stopPopupRetentionTracking(): void {
  if (pageHideHandler) {
    window.removeEventListener('pagehide', pageHideHandler);
    pageHideHandler = null;
  }
  activeRetention = null;
}
